<style>
</style>
<template>
  <div class="rechargeMsg-box">
    <p class="title">短信管理&nbsp;&nbsp;<strong>[ 充值记录 ]</strong></p>
    <div class="mb20 order-search-wrap">
      <span>变动账户：</span>
      <el-input placeholder="请输入变动账户" prefix-icon="el-icon-search" v-model="activeUserName" @keyup.enter.native="getChargeMsg"
                clearable style="width:200px;" maxlength="50" clearable></el-input>
      <span>目标账户：</span>
      <el-input placeholder="请输入目标账户" prefix-icon="el-icon-search" v-model="targerUserName" @keyup.enter.native="getChargeMsg"
                clearable style="width:200px;" maxlength="50" clearable></el-input>
      <el-button type="primary" class="ml20" @click="getChargeMsg()" >查询</el-button>
    </div>
    <div class="table-wrapper">
      <el-table :data="rechargeData" border v-loading = "loading" highlight-current-row ref="table" :max-height="tableHeight">
        <el-table-column label="变动账户" prop="activeUserName"></el-table-column>
        <el-table-column label="目标账户" prop="targerUserName"></el-table-column>
        <el-table-column label="短信变动额度" prop="changeBalance"></el-table-column>
        <el-table-column label="富信变动额度" prop="fuxinChangeBalance"></el-table-column>
        <el-table-column label="营销短信变动额度" prop="marketChangeBalance"></el-table-column>
        <el-table-column label="变动类型" prop="type"></el-table-column>
        <el-table-column label="变动时间" prop="createtime"></el-table-column>
      </el-table>
    </div>
    <div class="txt-r mtop20">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page="pageNum"
        :page-sizes="[20, 50, 100]"
        :page-size=pageSize
        layout="total, sizes, prev, pager, next, jumper"
        :total=total>
      </el-pagination>
    </div>
  </div>
</template>
<script>
import api from '../../server/api.js'
export default {
  name: "rechargeMsg",
  data(){
    return{
      activeUserName:"",
      targerUserName:"",
      tableHeight: 100,
      loading:false,
      pageSize: 20,//当前显示条数
      pageNum: 1,//当前页数
      total: 0,//总数
      rechargeData: [],
    };
  },
  created(){
    this.getChargeMsg()
  },
  methods: {
    getChargeMsg(){//获取列表
      let data = {
        "start": this.pageNum,
        "length": this.pageSize,
        // "startTime":
        // "endTime":
        "activeUserName": this.activeUserName,
        "targerUserName": this.targerUserName
      }
      this.loading =true;
      api.getBalanceChangeList({data:data}).then(res => {
        this.loading =false;
        this.tableHeight =
          window.innerHeight - this.$refs.table.$el.offsetTop - 100;
        if(res.status == 'success'){
          this.rechargeData = res.data.resultList;
          this.total = res.data.count;
        }
      })
    },
    sizeChange(v){//切换显示条数
      this.pageSize = v;
      this.getChargeMsg();
    },
    currentChange(v){//切换页数
      this.pageNum = v;
      this.getChargeMsg();
    },
  },
  components: {
    
  }
}
</script> 
  




// WEBPACK FOOTER //
// src/view/customer/rechargeMsg.vue